export default class PhoneSelector {
    constructor () {
      new Vue({
        el: '#phone-selector',
        data() {
          return {
            locations : window.locations,
            location : '',
          }
        },
        watch: {
          location(phone) {
            if (phone) {
              window.location.href = 'tel:' + phone;
            }
          }
        },
      })
    }
}

$(document).on("ready", () => (window.PhoneSelector = new PhoneSelector()));



// WEBPACK FOOTER //
// ./resources/js/PhoneSelector.js